import { trackEvent, axiosInstance } from "@hopper-b2b/api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { notifyFailedAuthPath } from "./paths";

interface NotifyFailedAuthOptions {
  apiConfig?: IApiConfig;
  /** Raw OAuth state string from NuPay callback (base64-encoded) */
  nupayOAuthState?: string;
}

export const notifyFailedAuth = (
  options?: NotifyFailedAuthOptions
): Promise<null> =>
  new Promise((resolve, reject) => {
    const body = options?.nupayOAuthState
      ? { state: options.nupayOAuthState }
      : undefined;

    axiosInstance
      .post(notifyFailedAuthPath, body)
      .then((res) => {
        const responseBody = res.data;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          options?.apiConfig
        );
        reject(e);
      });
  });
